export default __webpack_public_path__ + "static/media/leftArrowHover.b828644d.svg";